import { StandardFeature } from '../standard/standard.feature';
import { Layer } from '@app/modules/cop/store/cop/models';
import { Dataset, Document } from '@app/modules/core/store/models';
import { MarkerUrls } from '../feature.model';
import { API_BASE_URL } from '@app/core/constants';
import { getAlertColor } from '@app/features/operating-picture/7P';

export class SevenPTransportAlertFeature extends StandardFeature {
  buildMarkerImageUrls(layer: Layer, dataset: Dataset, document: Document, cacheBuster: number): MarkerUrls {
    const alertColor = getAlertColor(Number(document?.event_code));
    const markerColor = alertColor.replace('#', '');

    return {
      normal: `${API_BASE_URL}/v1/meta/markers/seven-p-alert-pin/${markerColor}/0/0/normal/seven-p-pin_${cacheBuster}.png`,
      selected: `${API_BASE_URL}/v1/meta/markers/seven-p-alert-pin/${markerColor}/0/0/selected/seven-p-pin_${cacheBuster}.png`
    };
  }
}
